/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Toast_DeletedInputs */

const en_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover letter deleted`)
};

const de_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben gelöscht`)
};

const fr_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettre de motivation supprimée`)
};

const es_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carta de presentación eliminada`)
};

const it_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettera di presentazione eliminata`)
};

const nl_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivatiebrief verwijderd`)
};

const pl_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List motywacyjny usunięty`)
};

const fi_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirje poistettu`)
};

const da_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbrev slettet`)
};

const sv_cover_letters_toast_deleted = /** @type {(inputs: Cover_Letters_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personligt brev raderat`)
};

/**
* | output |
* | --- |
* | "Cover letter deleted" |
*
* @param {Cover_Letters_Toast_DeletedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_toast_deleted = /** @type {((inputs?: Cover_Letters_Toast_DeletedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Toast_DeletedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_toast_deleted(inputs)
	if (locale === "fr") return fr_cover_letters_toast_deleted(inputs)
	if (locale === "es") return es_cover_letters_toast_deleted(inputs)
	if (locale === "it") return it_cover_letters_toast_deleted(inputs)
	if (locale === "nl") return nl_cover_letters_toast_deleted(inputs)
	if (locale === "pl") return pl_cover_letters_toast_deleted(inputs)
	if (locale === "fi") return fi_cover_letters_toast_deleted(inputs)
	if (locale === "da") return da_cover_letters_toast_deleted(inputs)
	if (locale === "sv") return sv_cover_letters_toast_deleted(inputs)
	return en_cover_letters_toast_deleted(inputs)
});